import React, { useContext } from 'react';
import { Maximize2, Minimize2 } from 'react-feather';
import Accordion from 'react-bootstrap/Accordion';
import AccordionContext from 'react-bootstrap/AccordionContext';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import Card from 'react-bootstrap/Card';
import { Link } from 'react-router-dom';

function ContextAwareToggle({ eventKey, _title, _subtitle, _icon, callback }) {
  const { activeEventKey } = useContext(AccordionContext);

  const decoratedOnClick = useAccordionButton(
    eventKey,
    () => callback && callback(eventKey),
  );

  const isCurrentEventKey = activeEventKey === eventKey;

  return (
    <div type="button" onClick={decoratedOnClick}>
      <div style={{ margin: "0.75rem 1.75rem 0.75rem 0.75rem" }}>
        <div style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ marginLeft: '10px', display: "flex", alignItems: "center" }}>
            {_icon && <img style={{ height: "55px", width: "55px", objectFit: "cover", borderRadius: "12px", marginRight: "14px", boxShadow: "0 2px 6px rgba(0,0,0,0.25)" }} src={_icon} alt={_title} />}
            <div>
              <span style={{ fontSize: "1.3em", fontWeight: "bold" }}>{_title}</span><br />
              <span style={{ fontSize: "0.9em", lineHeight: 'normal' }}>{_subtitle}</span>
            </div>
          </div>
          <div style={{ float: "left", display: "flex", alignItems: "center", height: "100%" }}>
            {isCurrentEventKey ? <Maximize2 size={32} /> : <Minimize2 size={32} />}
          </div>
        </div>
      </div>
    </div>
  );
}

export function PlaystoreApp({ itemNumber, title, subtitle, details, link, buttontxt, icon, appId }) {
  const privacyPolicyUrl = appId ? `/privacy-policy?app=${appId}` : '/privacy-policy';

  return (
    <Accordion style={{ width: "100%" }} defaultActiveKey={itemNumber}>
      <Card style={{ padding: "0px" }} className="mi-service col-12">
        <Card.Header style={{ padding: "0px", overflow: "hidden", width: "100%" }}>
          <ContextAwareToggle eventKey={itemNumber} _title={title} _subtitle={subtitle} _icon={icon} />
        </Card.Header>
        <Accordion.Collapse eventKey={itemNumber}>
          <Card.Body>
            {details && details.map((element, _index) => (
              <p style={{ textAlign: "justify", margin: "10px 0px" }} key={_index}>{element}</p>
            ))}

            <div style={{ marginTop: "18px", display: "flex", gap: "12px", alignItems: "center", flexWrap: "wrap" }}>
              {link ? (
                <a href={link} rel="noopener noreferrer" target="_blank" className="mi-button">
                  {buttontxt || "Descargar"}
                </a>
              ) : (
                <span className="mi-button" style={{ opacity: 0.75, cursor: "default" }}>
                  {buttontxt || "Próximamente"}
                </span>
              )}

              <Link to={privacyPolicyUrl} className="mi-button" style={{ background: "transparent", border: "1px solid #007bff", color: "#007bff" }}>
                Ver Política de Privacidad
              </Link>
            </div>
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  );
}
